import { createAsyncThunk } from '@reduxjs/toolkit'
import favoriteService from 'services/favorite'

export const getFavorites = createAsyncThunk(
  'favorites/list',
  async (userId: number) => favoriteService.list(userId)
)

export const addFavorite = createAsyncThunk(
  'favorites/add',
  async ({ userId, locationId }: { userId: number; locationId: number }) =>
    favoriteService.add(userId, locationId)
)

export const removeFavorite = createAsyncThunk(
  'favorites/remove',
  async ({ userId, locationId }: { userId: number; locationId: number }) =>
    favoriteService.remove(userId, locationId)
)
